import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "page-inner" }
const _hoisted_3 = { class: "page-content-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p id=\"js-color-profile\" class=\"d-none\"><span class=\"color-primary-50\"></span><span class=\"color-primary-100\"></span><span class=\"color-primary-200\"></span><span class=\"color-primary-300\"></span><span class=\"color-primary-400\"></span><span class=\"color-primary-500\"></span><span class=\"color-primary-600\"></span><span class=\"color-primary-700\"></span><span class=\"color-primary-800\"></span><span class=\"color-primary-900\"></span><span class=\"color-info-50\"></span><span class=\"color-info-100\"></span><span class=\"color-info-200\"></span><span class=\"color-info-300\"></span><span class=\"color-info-400\"></span><span class=\"color-info-500\"></span><span class=\"color-info-600\"></span><span class=\"color-info-700\"></span><span class=\"color-info-800\"></span><span class=\"color-info-900\"></span><span class=\"color-danger-50\"></span><span class=\"color-danger-100\"></span><span class=\"color-danger-200\"></span><span class=\"color-danger-300\"></span><span class=\"color-danger-400\"></span><span class=\"color-danger-500\"></span><span class=\"color-danger-600\"></span><span class=\"color-danger-700\"></span><span class=\"color-danger-800\"></span><span class=\"color-danger-900\"></span><span class=\"color-warning-50\"></span><span class=\"color-warning-100\"></span><span class=\"color-warning-200\"></span><span class=\"color-warning-300\"></span><span class=\"color-warning-400\"></span><span class=\"color-warning-500\"></span><span class=\"color-warning-600\"></span><span class=\"color-warning-700\"></span><span class=\"color-warning-800\"></span><span class=\"color-warning-900\"></span><span class=\"color-success-50\"></span><span class=\"color-success-100\"></span><span class=\"color-success-200\"></span><span class=\"color-success-300\"></span><span class=\"color-success-400\"></span><span class=\"color-success-500\"></span><span class=\"color-success-600\"></span><span class=\"color-success-700\"></span><span class=\"color-success-800\"></span><span class=\"color-success-900\"></span><span class=\"color-fusion-50\"></span><span class=\"color-fusion-100\"></span><span class=\"color-fusion-200\"></span><span class=\"color-fusion-300\"></span><span class=\"color-fusion-400\"></span><span class=\"color-fusion-500\"></span><span class=\"color-fusion-600\"></span><span class=\"color-fusion-700\"></span><span class=\"color-fusion-800\"></span><span class=\"color-fusion-900\"></span></p>", 1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<nav class=\"shortcut-menu d-none d-sm-block\"><input type=\"checkbox\" class=\"menu-open\" name=\"menu-open\" id=\"menu_open\"><label for=\"menu_open\" class=\"menu-open-button\"><span class=\"app-shortcut-icon d-block\"></span></label><a href=\"#\" class=\"menu-item btn\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Scroll Top\"><i class=\"fal fa-arrow-up\"></i></a><a href=\"#\" class=\"menu-item btn\" data-action=\"app-fullscreen\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Full Screen\"><i class=\"fal fa-expand\"></i></a><a href=\"#\" class=\"menu-item btn\" data-action=\"app-print\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Print page\"><i class=\"fal fa-print\"></i></a></nav>", 1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade js-modal-messenger modal-backdrop-transparent",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-dialog modal-dialog-right" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content h-100" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-header bg-trans-gradient d-flex align-items-center w-100" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center mt-1 mb-1 color-white" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, [
            /*#__PURE__*/_createElementVNode("span", {
              class: "rounded-circle profile-image d-block",
              style: {"background-image":"url('img/demo/avatars/avatar-d.png')","background-size":"cover"}
            })
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "info-card-text" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "javascript:void(0);",
              class: "fs-lg text-truncate text-truncate-lg text-white",
              "data-toggle": "dropdown",
              "aria-expanded": "false"
            }, [
              /*#__PURE__*/_createTextVNode(" Tracey Chang "),
              /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-down d-inline-block ml-1 text-white fs-md" })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "dropdown-menu" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "dropdown-item",
                href: "#"
              }, "Send Email"),
              /*#__PURE__*/_createElementVNode("a", {
                class: "dropdown-item",
                href: "#"
              }, "Create Appointment"),
              /*#__PURE__*/_createElementVNode("a", {
                class: "dropdown-item",
                href: "#"
              }, "Block User")
            ]),
            /*#__PURE__*/_createElementVNode("span", { class: "text-truncate text-truncate-md opacity-80" }, "IT Director")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("button", {
          type: "button",
          class: "close text-white position-absolute pos-top pos-right p-2 m-1 mr-2",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }, [
          /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body p-0 h-100 d-flex" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "msgr-list d-flex flex-column bg-faded border-faded border-top-0 border-right-0 border-bottom-0 position-absolute pos-top pos-bottom" }, [
          /*#__PURE__*/_createElementVNode("div", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "height-4 width-3 h3 m-0 d-flex justify-content-center flex-column color-primary-500 pl-3 mt-2" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
            ]),
            /*#__PURE__*/_createElementVNode("input", {
              type: "text",
              class: "form-control bg-white",
              id: "msgr_listfilter_input",
              placeholder: "Filter contacts",
              "aria-label": "FriendSearch",
              "data-listfilter": "#js-msgr-listfilter"
            })
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "flex-1 h-100 custom-scroll" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
              /*#__PURE__*/_createElementVNode("ul", {
                id: "js-msgr-listfilter",
                class: "list-unstyled m-0"
              }, [
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "tracey chang online"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-success status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-d.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" Tracey Chang "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic text-success fs-xs" }, " Online ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "oliver kopyuv online"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-success status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-b.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" Oliver Kopyuv "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic text-success fs-xs" }, " Online ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "dr john cook phd away"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-warning status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-e.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" Dr. John Cook PhD "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs" }, " Away ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "ali amdaney online"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-success status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-g.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" Ali Amdaney "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs text-success" }, " Online ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "sarah mcbrook online"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-success status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-h.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" Sarah McBrook "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs text-success" }, " Online ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "ali amdaney offline"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-a.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" oliver.kopyuv@gotbootstrap.com "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs" }, " Offline ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "ali amdaney busy"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-danger status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-j.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" oliver.kopyuv@gotbootstrap.com "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs text-danger" }, " Busy ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "ali amdaney offline"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle status status-sm" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-c.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" oliver.kopyuv@gotbootstrap.com "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs" }, " Offline ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("li", null, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "d-table w-100 px-2 py-2 text-dark hover-white",
                    "data-filter-tags": "ali amdaney inactive"
                  }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell align-middle" }, [
                      /*#__PURE__*/_createElementVNode("span", {
                        class: "profile-image-md rounded-circle d-block",
                        style: {"background-image":"url('img/demo/avatars/avatar-m.png')","background-size":"cover"}
                      })
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "d-table-cell w-100 align-middle pl-2 pr-2" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "text-truncate text-truncate-md" }, [
                        /*#__PURE__*/_createTextVNode(" +714651347790 "),
                        /*#__PURE__*/_createElementVNode("small", { class: "d-block font-italic fs-xs opacity-50" }, " Missed Call ")
                      ])
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "filter-message js-filter-message" })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", null, [
            /*#__PURE__*/_createElementVNode("a", { class: "fs-xl d-flex align-items-center p-3" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fal fa-cogs" })
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "msgr d-flex h-100 flex-column bg-white" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "custom-scroll flex-1 h-100" }, [
            /*#__PURE__*/_createElementVNode("div", {
              id: "chat_container",
              class: "w-100 p-4"
            }, [
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "time-stamp text-center mb-2 fw-400" }, "Jun 19")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-sent" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Hey Tracey, did you get my files?")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "text-right fw-300 text-muted mt-1 fs-xs" }, " 3:00 pm ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-get" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Hi"),
                  /*#__PURE__*/_createElementVNode("p", null, " Sorry going through a busy time in office. Yes I analyzed the solution. "),
                  /*#__PURE__*/_createElementVNode("p", null, " It will require some resource, which I could not manage. ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-300 text-muted mt-1 fs-xs" }, "3:24 pm")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-sent chat-start" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Okay")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-sent chat-end" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, " Sending you some dough today, you can allocate the resources to this project. ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "text-right fw-300 text-muted mt-1 fs-xs" }, " 3:26 pm ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-get chat-start" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Perfect. Thanks a lot!")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-get" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "I will have them ready by tonight.")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment chat-segment-get chat-end" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "chat-message" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Cheers")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "chat-segment" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "time-stamp text-center mb-2 fw-400" }, "Jun 20")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "border-faded border-right-0 border-bottom-0 border-left-0 flex-1 mr-3 ml-3 position-relative shadow-top" }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "pt-3 pb-1 pr-0 pl-0 rounded-0",
                tabindex: "-1"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  id: "msgr_input",
                  contenteditable: "true",
                  "data-placeholder": "Type your message here...",
                  class: "height-10 form-content-editable"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "height-8 px-3 d-flex flex-row align-items-center flex-wrap flex-shrink-0" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "javascript:void(0);",
                class: "btn btn-icon fs-xl width-1 mr-1",
                "data-toggle": "tooltip",
                "data-original-title": "More options",
                "data-placement": "top"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-v-alt color-fusion-300" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "javascript:void(0);",
                class: "btn btn-icon fs-xl mr-1",
                "data-toggle": "tooltip",
                "data-original-title": "Attach files",
                "data-placement": "top"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fal fa-paperclip color-fusion-300" })
              ]),
              /*#__PURE__*/_createElementVNode("a", {
                href: "javascript:void(0);",
                class: "btn btn-icon fs-xl mr-1",
                "data-toggle": "tooltip",
                "data-original-title": "Insert photo",
                "data-placement": "top"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fal fa-camera color-fusion-300" })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "ml-auto" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "btn btn-info"
                }, "Send")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade js-modal-settings modal-backdrop-transparent",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-dialog modal-dialog-right modal-md" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center w-100" }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "m-0 text-center color-white" }, [
          /*#__PURE__*/_createTextVNode(" Layout Settings "),
          /*#__PURE__*/_createElementVNode("small", { class: "mb-0 opacity-80" }, "User Interface Settings")
        ]),
        /*#__PURE__*/_createElementVNode("button", {
          type: "button",
          class: "close text-white position-absolute pos-top pos-right p-2 m-1 mr-2",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }, [
          /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
            /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body p-0" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "settings-panel" }),
        /*#__PURE__*/_createElementVNode("span", { id: "saving" })
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tm_leftnavi = _resolveComponent("Tm_leftnavi")!
  const _component_Tm_header = _resolveComponent("Tm_header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Tm_footer = _resolveComponent("Tm_footer")!

  return (_ctx.isMypage())
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Tm_leftnavi, {
              alertCount: _ctx.alertCount,
              "onUpdate:alertCount": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alertCount) = $event))
            }, null, 8, ["alertCount"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Tm_header),
              _createVNode(_component_router_view),
              _hoisted_4,
              _createVNode(_component_Tm_footer),
              _hoisted_5
            ])
          ])
        ]),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ], 64))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}